import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { HomeworkLink } from '../../../../../models/homework-link';
import { AssetService } from '../../../../../services/asset.service';
import { HomeworkService } from '../../../../../services/homework.service';
import { RouteService } from '../../../../../services/route.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ApplicationStateService } from '../../../../../services/application-state.service';
import { ModalComponent } from '../../../../../models/modal-component';
import { environment } from '../../../../../../environments/environment';
import { RestService } from '../../../../../services/rest.service';
import { SharingOptionsComponent } from '../../../../utils/sharing-options/sharing-options.component';
import {
    PlatformLinkCopiedConfirmationComponent
} from '../../../../utils/platform-link-copied-confirmation/platform-link-copied-confirmation.component';
import { TranslationPipe } from '../../../../../pipes/translation.pipe';
import { WorksheetService } from '../../../../../services/worksheet.service';
import { AssetPipe } from '../../../../../pipes/asset.pipe';

@Component({
    selector: 'page-homework-modal',
    templateUrl: './homework-modal.component.html',
    styleUrls: ['./homework-modal.component.scss'],
    standalone: true,
    imports: [
        SharingOptionsComponent,
        PlatformLinkCopiedConfirmationComponent,
        TranslationPipe,
        AssetPipe
    ]
})
export class HomeworkModalComponent extends ModalComponent implements OnInit, AfterViewInit {

    @Input() declare modalable: HomeworkLink;
    @ViewChild('modal') modal: ElementRef;

    downloadLink: string;
    link: string;
    title: string;

    platformLinkToShow: {
        platformName: string;
        logoURL: string;
        heading: string;
        description: string;
    };

    constructor(public applicationStateService: ApplicationStateService,
                public routeService: RouteService,
                public restService: RestService,
                public assetService: AssetService,
                private homeworkService: HomeworkService,
                public sanitizer: DomSanitizer,
                private worksheetService: WorksheetService) {
        super();
    }

    ngOnInit(): void {
        this.link = this.modalable.getLink();
        this.title = this.getTitle();
        this.downloadLink = this.homeworkService.getEvaluationLink(this.modalable);
    }

    ngAfterViewInit(): void {
        $(this.modal.nativeElement).on('hide.bs.modal', () => {
            this.onModalClose();
        });
    }

    /**
     * called when modal is closed
     */
    onModalClose(): void {
        this.homeworkService.closeHomework();
        setTimeout(() => {
            this.platformLinkToShow = undefined;
        }, 100);
    }

    // /**
    //  * get route to pdf (OLD implementation, on HAM server)
    //  * *
    //  * @return {string}
    //  */
    // getPdfDownload(): string|void {
    //     return `https://o-le.org/worksheet/${this.modalable.created}`;
    // }

    getPdfDownload() {
        const assignments = this.modalable.exercises.map(exercise => {
            if (typeof exercise === 'string') {
                return exercise;
            }

            return exercise.text;
        }).join(',');
        this.restService.post(
            environment.puppeteerDomain + this.routeService.getRelativeRoute(environment.endpointUrls.exportPdf, []),
            { assignments: assignments, title: this.modalable.title },
            new Headers({
                'Content-Type': 'application/json'
            }),
            'blob' as 'json'
        ).then((response: Blob) => {
            const blob = new Blob([response], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'export.pdf';
            a.click();
            window.URL.revokeObjectURL(url);
        }).catch(error => {
            console.error('Download error:', error);
        });
    }

    getTitle(): string {
        return this.modalable.title || `${this.modalable.domain}/${this.modalable.link}`;
    }

    isSvg(value: string): boolean {
        return value && value.trim().startsWith('<');
    }

    onOpenPlatformLinkModal($event: {
        platformName: string;
        logoURL: string;
        heading: string;
        description: string;
    }): void {
        this.platformLinkToShow = $event;
    }

    getId(): string {
        return this.modalable.getModalId();
    }

    openWorksheetEditor() {
        if (!this.modalable.worksheet) {
            this.worksheetService.createWorksheet(this.modalable).then(result => {
                this.worksheetService.openWorksheet(result);

                return;
            }).catch(error => {
                console.error(error);
            });
        } else {
            this.worksheetService.openHomeworkWorksheet(this.modalable);
        }
    }

    protected readonly open = open;
}
